/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M372.932 306.814c-6.335-3.172-37.436-18.515-43.252-20.63-5.798-2.115-10.022-3.172-14.245 3.173-4.205 6.344-16.338 20.63-20.042 24.86-3.686 4.23-7.373 4.767-13.708 1.595-6.335-3.173-26.729-9.87-50.902-31.464-18.801-16.809-31.508-37.568-35.213-43.913-3.686-6.364-.389-9.777 2.778-12.95 2.853-2.838 6.335-7.402 9.503-11.094 3.168-3.71 4.205-6.363 6.335-10.574 2.093-4.249 1.037-7.94-.537-11.113-1.593-3.172-14.245-34.377-19.505-47.067-5.15-12.374-10.373-10.686-14.245-10.89-3.705-.185-7.928-.222-12.133-.222-4.223 0-11.077 1.595-16.875 7.94-5.816 6.345-22.172 21.669-22.172 52.873 0 31.205 22.691 61.352 25.859 65.582 3.167 4.23 44.623 68.253 108.12 95.729 15.098 6.53 26.897 10.426 36.085 13.339 15.152 4.842 28.97 4.155 39.862 2.523 12.17-1.818 37.454-15.343 42.734-30.147 5.26-14.805 5.26-27.495 3.686-30.148-1.593-2.634-5.798-4.23-12.133-7.402M257.457 464.748h-.093c-37.788-.019-74.835-10.185-107.158-29.387l-7.687-4.582-79.688 20.945 21.265-77.826-5.001-7.977c-21.08-33.56-32.213-72.372-32.213-112.221.056-116.266 94.507-210.845 210.649-210.845 56.237.019 109.103 21.984 148.854 61.834 39.752 39.85 61.628 92.835 61.61 149.178-.056 116.284-94.507 210.88-210.538 210.88M436.634 74.413C388.807 26.455 325.216.02 257.438 0 117.828 0 4.186 113.798 4.13 253.681c-.018 44.729 11.633 88.363 33.805 126.84L2 512l134.295-35.286c36.991 20.203 78.65 30.87 121.05 30.87h.112c139.592 0 253.234-113.816 253.308-253.699.018-67.79-26.303-131.534-74.131-179.473"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconWhatsappAlt = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconWhatsappAlt.defaultProps = {
  theme,
};
IconWhatsappAlt.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconWhatsappAlt.displayName = 'IconWhatsappAlt';
export { IconWhatsappAlt };
